import {
  GET_STATIC_PAGE,
  POST_FEEDBACK,
  CLEAR_STATIC_PAGE
} from '../constants/staticPage';
import {
  defaultGetByIdAction,
  defaultCreateAction,
  defaultClearAction
} from '../utils/redux';

export const loadStaticPage = defaultGetByIdAction(GET_STATIC_PAGE, 'staticpages/');

export const postFeedback = defaultCreateAction(POST_FEEDBACK, 'contact_requests/');

export const clearStaticPage = defaultClearAction(CLEAR_STATIC_PAGE);



// WEBPACK FOOTER //
// ./src/actions/staticPage.js